import { Routes, Route } from 'react-router-dom'
import AdminLayout from './layouts/AdminLayout.jsx'
import ProtectedRoute from './components/ProtectedRoute.jsx'
import AuthInitializer from './components/AuthInitializer.jsx'
import Login from './pages/Login.jsx'
import Dashboard from './pages/Dashboard.jsx'
import UsersPage from './pages/UsersPage.jsx'
import UserVehiclesPage from './pages/UserVehiclesPage.jsx'
import VehiclesPage from './pages/VehiclesPage.jsx'
import SystemHealthPage from './pages/SystemHealthPage.jsx'
import UserDetailPage from './pages/UserDetailPage.jsx'
import VehicleDetailPage from './pages/VehicleDetailPage.jsx'
import NotificationsPage from './pages/NotificationsPage.jsx'
import SubscriptionsPage from './pages/SubscriptionsPage.jsx'

export default function Router() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />

      <Route
        element={
          <ProtectedRoute>
            <AuthInitializer>
              <AdminLayout />
            </AuthInitializer>
          </ProtectedRoute>
        }
      >
        <Route path="/" element={<Dashboard />} />
        <Route path="/users" element={<UsersPage />} />
        <Route path="/users/:userId" element={<UserDetailPage />} />
        <Route path="/users/:userId/vehicles" element={<UserVehiclesPage />} />
        <Route path="/vehicles" element={<VehiclesPage />} />
        <Route path="/vehicles/:vehicleUuid" element={<VehicleDetailPage />} />
        <Route path="/subscriptions" element={<SubscriptionsPage />} />
        <Route path="/notifications" element={<NotificationsPage />} />
        <Route path="/system" element={<SystemHealthPage />} />
      </Route>
    </Routes>
  )
}
